import { createVNode as _createVNode } from "vue";
import { IconWrapper } from '../runtime';
export default IconWrapper('target-one', false, function (props) {
  return _createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [_createVNode("path", {
    "d": "M23.8887 39.8888C32.7287 39.8888 39.8887 32.7288 39.8887 23.8888C39.8887 15.0488 32.7287 7.88882 23.8887 7.88882C15.0487 7.88882 7.88867 15.0488 7.88867 23.8888C7.88867 32.7288 15.0487 39.8888 23.8887 39.8888Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-miterlimit": "2",
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M23.8887 31.8888C28.3087 31.8888 31.8887 28.3088 31.8887 23.8888C31.8887 19.4688 28.3087 15.8888 23.8887 15.8888C19.4687 15.8888 15.8887 19.4688 15.8887 23.8888C15.8887 28.3088 19.4687 31.8888 23.8887 31.8888Z",
    "fill": props.colors[3],
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-miterlimit": "2",
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M23.8887 25.8888C24.9887 25.8888 25.8887 24.9888 25.8887 23.8888C25.8887 22.7888 24.9887 21.8888 23.8887 21.8888C22.7887 21.8888 21.8887 22.7888 21.8887 23.8888C21.8887 24.9888 22.7887 25.8888 23.8887 25.8888Z",
    "fill": props.colors[0]
  }, null), _createVNode("path", {
    "d": "M23.8887 7.88882V3.88882",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-miterlimit": "2",
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M37.8887 43.8888L33.8887 36.8888",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-miterlimit": "2",
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M13.8887 36.8888L9.88867 43.8888",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-miterlimit": "2",
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});